import React, { Component } from 'react';
import { observer, inject } from 'mobx-react/native';

import { StyleSheet, Text, View, TouchableHighlight } from 'react-native';
import { QSendNotification } from 'qunar-react-native';
import SizeUtil from '../../../utils/SizeUtil';
import { SelectCountryStoreModel } from '../../../stores/selectCountry/index';

const ROW_HEIGHT = 45;

interface Props {
    info: { item: { prenum: string; zh: string } };

    onTextChange?: (text: string) => void;
    toggleSearchPage?: (searchPage: boolean) => void;
}

@inject((store: SelectCountryStoreModel) => ({
    searchResult: store.searchBar.searchResult,
    onTextChange: store.searchBar.onTextChange,
    toggleSearchPage: store.searchBar.toggleSearchPage
}))
@observer
class CityItem extends Component<Props> {
    public itemOnPress = (prenum: string, zh: string) => {
        const { onTextChange, toggleSearchPage } = this.props;
        QSendNotification.sendNotification({
            name: 'cmnOrderRn-selectCountry-change',
            data: {
                prenum,
                zh
            }
        });
        onTextChange('');
        toggleSearchPage(false);
        Ext.back();
    };

    public render() {
        const { info } = this.props;
        if (!info) return <View />;
        return (
            <TouchableHighlight
                style={{ width: '100%', justifyContent: 'center' }}
                onPress={() => {
                    this.itemOnPress(info.item.prenum, info.item.zh);
                }}
                underlayColor="#F6F6F6"
            >
                <View style={styles.rowStyle}>
                    <Text>{info.item.zh}</Text>
                    <Text>{`+${info.item.prenum}`}</Text>
                </View>
            </TouchableHighlight>
        );
    }
}

const styles = StyleSheet.create({
    wrap: {
        zIndex: 99,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: 'rgba(33,33,33,0.4)'
    },
    rowStyle: {
        backgroundColor: '#fff',
        paddingLeft: SizeUtil.getSize(11),
        paddingRight: SizeUtil.getSize(11),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: '#eee',
        height: ROW_HEIGHT
    }
});

export default CityItem;
